import cookie from '@/utils/cookie'
import { languageZh, languageEn } from '@/utils/const'

var lang = navigator.language || navigator.userLanguage
lang = lang.substr(0, 2)
var language = ''
if (cookie.getCookie(cookie.language_cookie)) {
  language = cookie.getCookie(cookie.language_cookie)
} else {
  language = lang === 'zh' ? languageZh : languageEn
}

const state = {
  language: language,
  menulist: '',
  sidebar: {
    opened: cookie.getCookie('sidebarStatus') ? !!+cookie.getCookie('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: cookie.getCookie('size') || 'medium'
}
const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      cookie.setCookie('sidebarStatus', 1)
    } else {
      cookie.setCookie('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    cookie.setCookie('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    cookie.setCookie('size', size)
  }

}
const actions = {
  SetLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js